import logger from '@/utils/logger';

let deviceRegistered = false;
let isPostLogin = false;
let graceTimer: ReturnType<typeof setTimeout> | undefined;

const maybeEnd = () => {
  if (isPostLogin && deviceRegistered && !graceTimer) {
    postLoginCoordinator.end();
    window.dispatchEvent(new Event('postLoginEnded'));
  }
};

export const postLoginCoordinator = {
  start: (graceMs = 5000) => {
    postLoginCoordinator.end();
    isPostLogin = true;
    graceTimer = setTimeout(() => {
      graceTimer = undefined;
      maybeEnd();
    }, graceMs);
  },
  markDeviceRegistered: () => {
    deviceRegistered = true;
    maybeEnd();
  },
  end: () => {
    if (graceTimer) {
      clearTimeout(graceTimer);
      graceTimer = undefined;
    }
    deviceRegistered = false;
    isPostLogin = false;
  },
  isPostLogin: () => isPostLogin
};

const handleUserSignedOut = () => {
  logger.log('[postLoginCoordinator] userSignedOut detected - cleaning up');
  postLoginCoordinator.end();
};

window.addEventListener('userSignedOut', handleUserSignedOut);
